import { Div, Collection, CollectionPrinter, TextInput, NumberInput, DateInput, RefJsonViewer } from "@tblabs/truffle";
import { ProductSelector } from "../../../../Components/ProductSelector";
import { BasketItem } from "../../../../Models/Basket/BasketItem";
import { BasketItemType } from "../../../../Models/Basket/BasketItemType";
import { RentBasketItem } from "../../../../Models/Basket/RentBasketItem";
import { SaleBasketItem } from "../../../../Models/Basket/SaleBasketItem";
import { RawProductFromWebsite } from "../../../../Models/ProductsCatalog/RawProduct";
import { Entry } from "./Entry";
import { InfoFrame } from "../../../../Components/Utils/InfoFrame";


export class BasketEdit extends Div
{
    constructor(_productsInfo: RawProductFromWebsite[], basket: Collection<BasketItem>)
    {
        super();

        this.Append(
            new InfoFrame("", `Dodawanie i usuwanie produktów odbywa się w krokach AddToBasket. Tutaj można tylko edytować szczegóły istniejących produktów we wszystkich tych krokach.`),
            new CollectionPrinter(basket, x =>
            {
                switch (x.Type)
                {
                    case BasketItemType.Rent:
                        const rentItem = x as RentBasketItem;
                        return new Entry(rentItem, basket, [], false)
                            .SetTitle(`Wypożyczenie`)
                            .AddField("Produkt", new ProductSelector(_productsInfo, rentItem))
                            .AddInput("Unikalny numer", new TextInput(rentItem.ProductSerialNumber).Bold())
                            .AddInput("Dane dostępowe", new TextInput(rentItem.AccessData))
                            .AddField("", new RefJsonViewer(rentItem.AccessData))
                            .AddInput("Ilość", new NumberInput(rentItem.Quantity))
                            .AddInput("Koszt całości (w PLN)", new NumberInput(rentItem.TotalPrice))
                            .AddInput("Depozyt łącznie (w PLN)", new NumberInput(rentItem.Deposit))
                            .AddInput("Początek użytkowania", new DateInput(rentItem.From))
                            .AddInput("Koniec użytkowania", new DateInput(rentItem.To));

                    case BasketItemType.Sale:
                        const saleItem = x as SaleBasketItem;
                        return new Entry(saleItem, basket, [], false)
                            .SetTitle(`Sprzedaż`)
                            .AddField("Produkt", new ProductSelector(_productsInfo, saleItem))
                            .AddInput("Unikalny numer", new TextInput(saleItem.ProductSerialNumber).Bold())
                            .AddInput("Dane dostępowe", new TextInput(saleItem.AccessData))
                            .AddField("", new RefJsonViewer(saleItem.AccessData))
                            .AddInput("Ilość", new NumberInput(saleItem.Quantity))
                            .AddInput("Koszt całości (w PLN)", new NumberInput(saleItem.TotalPrice));

                    default:
                        return `No edit form for ${x.Type}`;
                }
            }).Class("panels-container")
        );
    }
}
